import { types } from '../types';

export const textInputReducer = (
	state = {
		text: '',
		forceLoadToggle: false,
		refreshToggle: false,
	},
	action: any,
) => {
	switch (action.type) {
		case types.WEB_TEXT_INPUT:
			return {
				...state,
				text: action.text,
				forceLoadToggle: !state.forceLoadToggle,
			};
		case types.REFRESH_TEXT_INPUT:
			return { ...state, refreshToggle: !state.refreshToggle };
		default:
			return state;
	}
};
